import React, { PropTypes } from 'react';
import classnames from 'classnames';

const OPTIONS = [
  {
    icon: 'facebook',
    getUrl: ({ facebook: { link } }) => `https://www.facebook.com/sharer/sharer.php?u=${link}`
  },
  {
    icon: 'twitter',
    getUrl: ({ twitter: { content } }) => `https://twitter.com/intent/tweet?text=${content}`
  },
  {
    icon: 'linkedin',
    getUrl: ({ linkedin: { link, title, summary } }) => (
      `https://www.linkedin.com/shareArticle?mini=true&url=${link}&title=${title}&summary=${summary}`
    )
  },
  {
    icon: 'envelope',
    getUrl: ({ email: { subject, body } }) => `mailto:?&subject=${subject}&body=${body}`
  }
]

const Share = (props) => (
  <section className={classnames('block block-share thin', props.className, props.background)}>
    { !!props.title &&
    <div className="row columns">
      <div className="block-header">
        <h2 className="as-h3-important">{ props.title }</h2>
      </div>
    </div>
    }
    <div className="row columns">
      <div className="options">
        {OPTIONS.map((option, i) => (
          <a key={i} className="option" href={option.getUrl(props)} target="_blank">
            <i className={`fa fa-${option.icon}`}/>
          </a>
        ))}
      </div>
    </div>
  </section>
);

Share.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  facebook: PropTypes.object,
  twitter: PropTypes.object,
  linkedin: PropTypes.object,
  email: PropTypes.object,
  background: PropTypes.string,
};

export default Share;
